import React, { useState } from "react";
import PolarisRowActionsMenu from "./PolarisRowActionsMenu";

function normalizeHost(value: string): string {
    return value.trim().toLowerCase().replace(/^https?:\/\//, "").replace(/\/.*$/, "");
}

export default function AssistAllowedDomainsField({
    domains,
    onChange,
}: {
    domains: string[];
    onChange: (domains: string[]) => void;
}) {
    const [domainInput, setDomainInput] = useState("");
    const [editingDomain, setEditingDomain] = useState<string | null>(null);
    const [editValue, setEditValue] = useState("");

    const addDomain = () => {
        const host = normalizeHost(domainInput);
        if (!host || domains.includes(host)) {
            setDomainInput("");
            return;
        }
        onChange([...domains, host]);
        setDomainInput("");
    };

    const removeDomain = (host: string) => {
        onChange(domains.filter((item) => item !== host));
        if (editingDomain === host) {
            setEditingDomain(null);
        }
    };

    const saveEditedDomain = () => {
        if (!editingDomain) return;
        const host = normalizeHost(editValue);
        if (!host) return;
        onChange([...new Set(domains.map((item) => (item === editingDomain ? host : item)))]);
        setEditingDomain(null);
        setEditValue("");
    };

    return (
        <div className="pa-assist-reviewers">
            <p className="pa-assist-reviewers-title">Allowed websites</p>
            <div className="pa-assist-evaluator-row">
                <input
                    className="pa-filter-input"
                    type="text"
                    value={domainInput}
                    placeholder="ncaa.org"
                    aria-label="Website to allow"
                    onChange={(e) => setDomainInput(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            addDomain();
                        }
                    }}
                />
                <button type="button" className="pa-page-btn" onClick={addDomain}>
                    Add website
                </button>
            </div>
            {domains.length > 0 ? (
                <ul className="pa-assist-evaluator-list">
                    {domains.map((host) => (
                        <li key={host} className="pa-assist-evaluator-chip">
                            {editingDomain === host ? (
                                <>
                                    <input
                                        className="pa-filter-input"
                                        type="text"
                                        value={editValue}
                                        aria-label={`Edit website ${host}`}
                                        onChange={(e) => setEditValue(e.target.value)}
                                    />
                                    <div className="pa-assist-chip-actions">
                                        <button type="button" className="pa-page-btn" onClick={saveEditedDomain}>
                                            Save
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <span className="pa-assist-chip-label">{host}</span>
                                    <div className="pa-assist-chip-actions">
                                        <PolarisRowActionsMenu
                                            ariaLabel={`Actions for ${host}`}
                                            actions={[
                                                {
                                                    id: "edit",
                                                    label: "Edit",
                                                    onSelect: () => {
                                                        setEditingDomain(host);
                                                        setEditValue(host);
                                                    },
                                                },
                                                {
                                                    id: "remove",
                                                    label: "Remove",
                                                    variant: "destructive",
                                                    onSelect: () => removeDomain(host),
                                                },
                                            ]}
                                        />
                                    </div>
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="pa-assist-empty">No websites yet. Add an official site such as ncaa.org.</p>
            )}
        </div>
    );
}
